import { createContext } from 'react';
import { decorate, observable, action, computed } from 'mobx';

import * as fn from '../utilities/_functions';
import api from '../api';

export class BookingUserUpdate {
    data = null;
    originalData = null;
    isLoading = false;
    isSaving = false;
    isReady = false;
    cancelBookingUserGet = null;

    initialize = () => {
        const that = this;

        this.clear();
        this.isReady = false;

        return new Promise((resolve, reject) => {
            that.refresh()
                .then(() => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    that.isReady = true;
                })
        })
    }

    refresh = () => {
        const that = this;

        return new Promise((resolve, reject) => {
            that.isLoading = true;
            api.Users.search({
                parameters: [
                    { field: 'AcceptBooking', value: true },
                    { field: 'IsHidden', value: false },
                    { field: 'DeactivatedDateUtc', value: null },
                ],
                sortByFields: [
                    { field: 'Salutation', direction: 'ASC' },
                    { field: 'FirstName', direction: 'ASC' },
                    { field: 'LastName', direction: 'ASC' }
                ],
                loadProperties: true,
                includeAdministrators: false,
            }, (c) => { that.cancelBookingUserGet = c; })
                .then(({ data }) => {
                    that.originalData = data.result && data.result.length > 0 ? data.result : [];
                    that.data = data.result && data.result.length > 0 ? data.result : [];
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    that.isLoading = false;
                })
        })
    }

    update = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            if (that.hasUnsavedChanges) {
                Promise.all(that.unsavedChanges.map(d => {
                    return api.Users.onlineBooking(d.id, { acceptOnlineBooking: d.acceptOnlineBooking })
                }))
                    .then(() => {
                        that.refresh();
                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    })
                    .finally(() => {
                        that.isSaving = false;
                    })
            }
            else {
                that.isSaving = false;
            }
        })
    }

    clear = () => {
        this.data = null;
        this.originalData = null;
        this.isLoading = false;
        this.isSaving = false;
        this.isReady = false;

        if (fn.isFunction(this.cancelBookingUserGet)) {
            this.cancelBookingUserGet();
            this.cancelBookingTypeGet = null;
        }
    }

    get unsavedChanges() {
        const result = this.data && this.data.length > 0 ? 
            this.data.filter(d => this.originalData.some(o => o.id === d.id && o.acceptOnlineBooking !== d.acceptOnlineBooking)) : [];

        return result && result.length > 0 ? result : [];
    }

    get hasUnsavedChanges() {
        return !!this.unsavedChanges && this.unsavedChanges.length > 0;
    }

    get removeUsers() {
        if (!!this.unsavedChanges && this.unsavedChanges.length > 0) {
            return this.unsavedChanges.some(d => !d.acceptOnlineBooking) ? this.unsavedChanges.filter(d => !d.acceptOnlineBooking) : [];
        }

        return [];
    }
}

decorate(BookingUserUpdate, {
    data: observable,
    originalData: observable,
    isLoading: observable,
    isSaving: observable,
    isReady: observable,
    initialize: action,
    update: action,
    clear: action,
    unsavedChanges: computed,
    hasUnsavedChanges: computed,
    removeUsers: computed,
})

export default createContext(new BookingUserUpdate());